import { make as make$1, render as render$1 } from '../../internal/logSpan.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * @since 2.0.0
 * @category destructors
 */
const render = render$1;

export { make, render };
